// "Estimated monthly loss range" card. Verbatim from PaidReport.jsx (W2c).
// Renders the engine-computed loss min/max, midpoint, and annualized range.
export default function ReportLossCard({
  estimatedMonthlyLossMin,
  estimatedMonthlyLossMax,
  estimatedMonthlyLossMidpoint,
}) {
  return (
    <div className="sf-card" style={{ marginBottom: 36 }} data-testid="paid-report-loss-card">
      <div className="sf-eyebrow" style={{ marginBottom: 10 }}>Estimated monthly loss range</div>
      <div className="sf-loss-range" style={{ fontSize: 28 }} data-testid="paid-report-loss-range">
        ${estimatedMonthlyLossMin?.toLocaleString?.()}–${estimatedMonthlyLossMax?.toLocaleString?.()}
      </div>
      <div className="sf-mono sf-muted-text" style={{ marginTop: 6 }}>
        Midpoint ${estimatedMonthlyLossMidpoint?.toLocaleString?.()} &middot; Annualized ${(estimatedMonthlyLossMin * 12).toLocaleString()}–${(estimatedMonthlyLossMax * 12).toLocaleString()}
      </div>
    </div>
  );
}
